import AdditionalQuestions from './AdditionalQuestions';
import ApplianceTenant from './ApplianceTenant';
import Comment from './Comment';
import CommentPlain from './CommentPlain';
import Collaborators from './Collaborators';
import Email from './Email';
import Region from './Region';
import RootTenantAuthority from './RootTenantAuthority';
import Severity from './Severity';
import Subject from './Subject';
import Tenant from './Tenant';
import TenantName from './TenantName';
import Type from './Type';

/**
 * Aggregation of fields used in NewTicketForm
 */
export default {
  AdditionalQuestions,
  ApplianceTenant,
  Comment,
  CommentPlain,
  Collaborators,
  Email,
  Region,
  RootTenantAuthority,
  Severity,
  Subject,
  Type,
  Tenant,
  TenantName
};
